'use client'

import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Link from '@/components/common/Link'
import { defaultLocale } from '@/utils/locale'

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <Box sx={{ flexGrow: 1, py: 8, textAlign: 'center' }}>
      <Typography variant='h1'>{t('Page Not Found')}</Typography>
      <Typography variant='body1' sx={{ mt: 2 }}>
        <Link href={`/${defaultLocale}/`}>{t('Return Home')}</Link>
      </Typography>
    </Box>
  )
}
